import React from 'react';

export type ChipProps = {
  label: string;
  removable?: boolean;
  onRemove?: () => void;
  className?: string;
  size?: 'sm' | 'md';
};

const Chip = ({
  label,
  removable = false,
  onRemove,
  className = '',
  size = 'md',
}: ChipProps) => {
  // Define the chip's size-based padding
  const sizeClasses =
    size === 'sm' ? 'text-[0.75rem] px-2 py-0.5' : 'text-xs px-3 py-1';

  const base = `
    inline-flex items-center font-medium transition
    ${sizeClasses}
    bg-gray-500 text-white rounded-md cursor-pointer
    hover:bg-gray-400 mt-2
    ${className}
  `;

  const handleClick = () => {
    if (removable && onRemove) onRemove();
  };

  return (
    <div className={base} onClick={handleClick}>
      <span>{label}</span>
      {removable && onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-1 text-s font-bold"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Chip;
